import { render, staticRenderFns } from "./declarationReview.vue?vue&type=template&id=6690c75e"
import script from "./declarationReview.vue?vue&type=script&lang=js"
export * from "./declarationReview.vue?vue&type=script&lang=js"
import style0 from "./declarationReview.vue?vue&type=style&index=0&id=6690c75e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports